import { classes } from 'src/utils'

type Props = {
  icon: React.ReactElement
  className?: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}
export function IconButton(props: Props) {
  return (
    <button
      onClick={props.onClick}
      className={classes('w-8 h-8 p-2 rounded-full', props.className)}
    >
      {props.icon}
    </button>
  )
}
